import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "../lib/api";

export default function ReviewsStrip({ limit = 6 }) {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/site/reviews")
            .then(({ data }) => setReviews((data || []).slice(0, limit)))
            .catch(() => setReviews([]))
            .finally(() => setLoading(false));
    }, [limit]);

    if (loading || reviews.length === 0) return null;

    const avg = reviews.reduce((s, r) => s + (r.rating || 5), 0) / reviews.length;

    return (
        <section data-testid="reviews-strip" className="border-y border-[var(--border-soft)]" style={{ background: "var(--bg-warm)" }}>
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
                <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
                    <div>
                        <p className="label-tiny" style={{ color: "var(--rose-deep)" }}>★ Wat klanten zeggen</p>
                        <h2 className="font-display text-3xl md:text-4xl mt-2 leading-tight">
                            <span className="inline-flex items-center gap-2 align-middle">
                                {Array(5).fill(0).map((_, i) => (
                                    <Star key={i} size={20} fill={i < Math.round(avg) ? "var(--gold)" : "transparent"} style={{ color: "var(--gold)" }} strokeWidth={1.5} />
                                ))}
                            </span>
                            <span className="ml-2">{avg.toFixed(1)} van 5</span>
                        </h2>
                    </div>
                    <p className="text-xs" style={{ color: "var(--text-2)" }}>{reviews.length}+ tevreden klanten — geverifieerd door VdS Gift Shop</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {reviews.map((r) => (
                        <div key={r.id} data-testid={`review-card-${r.id}`} className="card-soft bg-white p-6 relative">
                            <Quote size={20} className="absolute top-4 right-4 opacity-30" style={{ color: "var(--rose-deep)" }} />
                            <div className="flex items-center gap-1">
                                {Array(r.rating || 5).fill(0).map((_, i) => (
                                    <Star key={i} size={13} fill="var(--gold)" style={{ color: "var(--gold)" }} strokeWidth={1.5} />
                                ))}
                            </div>
                            <p className="text-sm mt-3 leading-relaxed" style={{ color: "var(--text)" }}>&ldquo;{r.quote || r.message || r.text}&rdquo;</p>
                            <p className="text-xs mt-4 font-semibold" style={{ color: "var(--text-2)" }}>
                                — {r.author || r.name}{r.location ? `, ${r.location}` : ""}{r.product_type ? <span className="font-normal" style={{ color: "var(--text-3)" }}> · {r.product_type}</span> : null}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
